import { FormattedMessage } from 'react-intl';
import React from 'react';
import { BATCHES_VIEW_ID, BATCHES_ADVANCED_SEARCH_VIEW_ID } from './view-id-constants';

export const BatchesAdvancedSearch = {
  label: <FormattedMessage defaultMessage='Advanced Search' description='shipmentsPage.nav.advancedSearch' id='9OxkT5' />,
  id: BATCHES_ADVANCED_SEARCH_VIEW_ID,
  navigationOverride: '/shipments/batches/advanced-search',
  parentId: BATCHES_VIEW_ID,
};
